export default __webpack_public_path__ + "static/backgroundSteps-aeee1d10165b373ca8ad57a5b67c0ed6.svg";